import React, { useEffect, useState } from "react";
import { useSortBy, useTable } from "react-table";


import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { TooltipManage } from "./TooltipManage";

export function CreateTableForEmployeesBiometrics({ dataList = [],
  dataHeader = [],
  dataAccessor = [],
  employees,
  setDataToAdd,
  setAddConfirmation,
  selectedToAdd,
  setSelectedToAdd,
  isSelectAll,
  isAdd,
  setIsAdd,

  currentPage, setCurrentPage,
}) {
  const itemsPerPage = 7;

  const columns = React.useMemo(() =>
    dataHeader.map((header, index) => ({
      Header: header,
      accessor: dataAccessor[index]
    })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? []  // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
      }
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" }
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${sortHeaderValue.id === column.id
                    ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                    : ""
                    }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 &&
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          }
          {currentItems.map((row) => {
            prepareRow(row)
            return (
              employees.length > 0 ?
                <tr key={row.original.id}
                  {...row.getRowProps()}
                >
                  {row.cells.map((cell) => (
                    <SetInfoForEmployeesBiometrics
                      header={cell.render("Cell").props.column.Header}
                      _cell={cell}
                      employees={employees}
                      setDataToAdd={setDataToAdd}
                      setAddConfirmation={setAddConfirmation}
                      selectedToAdd={selectedToAdd}
                      setSelectedToAdd={setSelectedToAdd}
                      isSelectAll={isSelectAll}
                      isAdd={isAdd}
                      setIsAdd={setIsAdd}
                    />
                  ))}
                </tr>
                :
                <></>
            )
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage && employees.length > 0 ? (
        <div>
          <div className='table-page row' style={{ alignItems: "center", justifyContent: "end", padding: "20px 0 0 0" }}>
            <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "25px" }}>
              &lt;&lt;
            </button>
            <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "25px" }}>
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight: "5px", height: "25px" }}>
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height: "25px" }}>
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) :
        <></>}
    </div>
  )
}
function SetInfoForEmployeesBiometrics({ header,
  _cell,
  employees,
  setDataToAdd,
  setAddConfirmation,
  selectedToAdd,
  setSelectedToAdd,
  isSelectAll,
  isAdd,
  setIsAdd
}) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setIsChecked(isSelectAll);
  }, [isSelectAll]);

  useEffect(() => {
    if (isAdd) {
      setIsChecked(false)
      setIsAdd(false)
    }
  }, [isAdd, setIsAdd]);

  const singleAdd = (selectedData) => {
    setDataToAdd(selectedData);
    setAddConfirmation(true);
  }

  const handleItem = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);

    if (checked) {
      setSelectedToAdd(prevItems => [...prevItems, data]);
    } else {
      setSelectedToAdd(prevItems => prevItems.filter(i => i !== data));
    }
  };

  if (header === "Photo") {
    return (
      <td>
        <img className="avatarImg" src="images/sample.jpg" alt="" />
      </td>
    )
  }

  if (header === "Status") {
    if (!value) {
      return (
        <td>
          Pending
        </td>
      )
    }

    return (
      <td>
        {_cell.render("Cell").props.value}
      </td>
    )
  }

  if (header === "") {
    const foundEmployee = employees.find(employee => {
      return employee.employeeId.toString().trim() === data.employeeId.toString().trim()
    })

    if (foundEmployee) {
      return (
        <td></td>
      )
    }

    return (
      <td>
        <div className="row" style={{ alignItems: "center", justifyContent: "center" }}>
          <TooltipManage text="Add">
            <div style={{ padding: "0 5px" }} onClick={() => singleAdd(data)}><PersonAddAltIcon /></div>
          </TooltipManage>

          <input type="checkbox"
            id="overtime-allowance"
            className="checkbox"
            name=""
            checked={isChecked}
            onChange={handleItem}
          />
        </div>

      </td>
    )
  }

  if (header === "Date Created"
  ) {
    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return (
        <td>
          null
        </td>
      );
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return (
      <td>
        {formattedDateFrom}
      </td>
    )
  }

  return (
    <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
  )
}